import { createStoreProvider, useStore } from "impact-react";
import { router } from "router";

import { useEditor } from "./editor";
import { useGit } from "./git";
import { useLiveSession } from "./live-session";
import { runSandboxMigration } from "./sandboxMigration";
import type { EditorStoreProps } from "./types";

function EditorStore(props: EditorStoreProps) {
  const editor = useEditor(props);
  const git = useGit(props);
  const liveSession = useLiveSession(props);

  if (typeof router.queries.migrateFrom === "string") {
    runSandboxMigration(props);
  }

  return {
    editor,
    git,
    liveSession,
  };
}

export const useEditorStore = () => useStore(EditorStore);

export const EditorStoreProvider = createStoreProvider(EditorStore);
